<ng-template #searchResultTemplate let-r="result" let-t="term">
  <div [innerHTML]="r.name"></div>
</ng-template>

<ng-container *ngIf="cart$ | async as cart">
  <h3 [innerHTML]="'quickOrderCartForm.title' | mbTranslate"></h3>
  <form (ngSubmit)="applyQuickOrder()"
        [formGroup]="quickOrderForm">
    <div class="row">
      <div class="col-md-9">
        <div class="row">
          <div class="col-8">
            <input class="form-control"
                   formControlName="productCode"
                   [attr.aria-label]="'quickOrderCartForm.entryProductCode' | mbTranslate"
                   [placeholder]="'quickOrderCartForm.productCodePlaceholder' | mbTranslate">
          </div>
          <div class="col-4">
            <div class="form-control p-1 d-flex justify-content-between">
              <input class="text-center border-0 w-100"
                     type="number"
                     [min]="min"
                     [max]="max"
                     [step]="step"
                     aria-required="true"
                     formControlName="quantity"
                     required="true"
                     [attr.aria-label]="'quickOrderCartForm.quantity' | mbTranslate">
              <div class="btn-group-vertical">
                <button type="button"
                        class="btn-up p-0 m-0"
                        [disabled]="quantity >= max"
                        (click)="quantity = quantity + step">
                  <img src="/assets/icons/svg/arrow_up.svg" alt="+">
                </button>
                <button type="button"
                        class="btn-down p-0 m-0"
                        [disabled]="quantity <= min"
                        (click)="quantity = quantity - step">
                  <img src="/assets/icons/svg/arrow_down.svg" alt="-">
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <button class="btn btn-block btn-primary"
                type="submit"
                [attr.aria-label]="'quickOrderCartForm.addToCart' | mbTranslate"
                [class.disabled]="quickOrderForm.invalid"
                [disabled]="quickOrderForm.invalid"
                [innerHTML]="'quickOrderCartForm.add' | mbTranslate">
        </button>
      </div>
    </div>
  </form>
</ng-container>
